import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { DialogActions, Divider } from "@mui/material";
import "../../styles/components/Editor.scss";
import "../../styles/components/EditorModal.scss";

export default function FootnoteSymbolModal({
  openFootnote,
  onClose,
  onSelectSymbol,
  currentFootnoteText,
  currentSymbol, usedSymbols, setusedSymbols
}) {
  const footnoteSymbols = [
    "*",
    "†",
    "€",
    "¶",
    "§",
    "#",
    "@",
    "$",
    "!",
    "‡",
    "||",
    "µ",
    "¥",
    "^",
    "~",
    "**",
    "***",
    "£",
    "▼",
    "△",
    "®",
    "I",
    "II",
    "III",
    "IV",
    "V",
    "VI",
    "VII",
    "VIII",
    "IX",
    "X",
  ];

  const [selectedSymbol, setSelectedSymbol] = useState(currentSymbol);
  const [hoveredSymbol, setHoveredSymbol] = useState(null);

  const handleSymbolClick = (symbol) => {
    if (selectedSymbol === symbol) {
      setSelectedSymbol(null);
    } else {
      setSelectedSymbol(symbol);
    }
  };

  const storedSymbols = localStorage.getItem('allSymbols') || '[]';
  const textSymbolMap = new Map(JSON.parse(storedSymbols));

  useEffect(() => {
    if (textSymbolMap.size > 0) {
      let symbolsArray = []
      textSymbolMap.forEach((value, key) => {
        if (!(value === 'Not Assigned' || value === undefined || value === null)) {
          symbolsArray.push(value)
        }
      })
      setusedSymbols(symbolsArray)
      setSelectedSymbol(currentSymbol)
    }

    return () => {
      setSelectedSymbol('')
    }

  }, [])
  function assignSymbol() {
    textSymbolMap.set(currentFootnoteText, selectedSymbol);
    localStorage.setItem('allSymbols', JSON.stringify(Array.from(textSymbolMap.entries())));
    window.dispatchEvent(new Event('symbolChange'));

    if (textSymbolMap.size > 0) {
      let symbolsArray = []
      textSymbolMap.forEach((value, key) => {
        if (!(value === 'Not Assigned' || value === undefined || value === null)) {
          symbolsArray.push(value)
        }
      })
      setusedSymbols(symbolsArray)
    }
  }


  const handleAdd = () => {
    assignSymbol()
    if (selectedSymbol) {
      onSelectSymbol(selectedSymbol);
      onClose();
    }
  };

  const handleMouseEnter = (symbol) => {
    setHoveredSymbol(symbol);
  };

  const handleMouseLeave = () => {
    setHoveredSymbol(null);
  };
  let allUsedSymbols = usedSymbols?.filter(item => item !== currentSymbol)
  return (
    <Dialog
      open={openFootnote}
      onClose={onClose}
      PaperProps={{
        style: {
          maxWidth: 699,
        },
      }}
      className="footnote exportAsModal"
      aria-labelledby="form-dialog-title2"
    >
      <DialogTitle id="customized-dialog-title">
        <div className="baseOnModalHeadingfootnote">
          ASSIGN FOOTNOTES SYMBOL
        </div>
      </DialogTitle>
      <DialogContent id="footnote-content">
        <div
          className="symbolsContainer"
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "20px",
          }}
        >
          {footnoteSymbols.map((symbol, index) => {
            return (
              <div
                key={index}
                onClick={allUsedSymbols.includes(symbol) || ((selectedSymbol || currentSymbol) === symbol) ? () => { } : () => handleSymbolClick(symbol)}
                onMouseEnter={allUsedSymbols.includes(symbol) ? () => { } : () => handleMouseEnter(symbol)}
                onMouseLeave={handleMouseLeave}
                className={`symbolBox ${(selectedSymbol || currentSymbol) === symbol ? "selected" : ""
                  }`}
                style={{
                  width: "77px",
                  height: "77px",
                  color: allUsedSymbols.includes(symbol) ? '#A9AAAC' :
                    (selectedSymbol || currentSymbol) === symbol
                      ? "#203662"
                      : hoveredSymbol === symbol
                        ? "#000000"
                        : "#1E1E1E",
                  borderRadius: "6px",
                  border: '1px solid #D1E6E6',
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: allUsedSymbols.includes(symbol) ? 'not-allowed' : "pointer",
                  fontSize: "28px",
                  backgroundColor: allUsedSymbols.includes(symbol) ? '#F2F3F3' :
                    (selectedSymbol || currentSymbol) === symbol
                      ? "#D1E6E6"
                      : hoveredSymbol === symbol
                        ? "#d1e6e6"
                        : "transparent",
                  transition: "background-color 0.2s ease",
                }}
              >
                {symbol}
              </div>)
          })}
        </div>
      </DialogContent>

      <DialogActions className="infoSDialog" style={{ height: "60px", boxShadow: "0px -2px 4px rgba(0, 0, 0, 0.0824)" }}>
        <div className="footerActions">
          <Button className="closeButtn" onClick={onClose}>
            CANCEL
          </Button>
          <Button
            style={{ height: "32px", width: "88px" }}
            disabled={!selectedSymbol}
            className={selectedSymbol ? "updateButtonSymbol assignSymbl" : "disbledUpdateSymbol assignSymbl"}
            onClick={handleAdd}
          >
            ADD
          </Button>
        </div>
        <Divider className="DialogFooterLine"></Divider>
      </DialogActions>
    </Dialog >
  );
}
